import React, { useState } from "react";
import { darken } from '@mui/system';
import { GoToDashboardButton } from "../../../../Global_Component/GlobalButtonComponent";
import {
  Grid,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  IconButton,
  TextField,
  Chip,
  Paper,
  colors,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import MessageIcon from "@mui/icons-material/Message";
import CloseIcon from "@mui/icons-material/Close";

import {
  CustomSecondaryEditButton,
  CustomSecondaryDownLoadButton,
  CustomSecondaryButton,
  CustomSuccessButton,
} from "../../../../Global_Component/GlobalButtonComponent";
import { Provider } from "react-redux";

const serviceProviders = ["CRM", "Shariah", "R&D Pre audit", "Finance", "Audit", "Client", "R&D Post audit"];

const ProductListPage = () => {
  const [products] = useState([
    {
      id: 1,
      name: "Beef bar",
      category: "Meat, seafood, and poultry",
      usage: "Ready to eat products",
    },
    {
      id: 2,
      name: "Oat meal",
      category: "Eggs and egg products",
      usage: "Ready to eat products",
    },
    {
      id: 3,
      name: "Chicken snacks",
      category: "Flavor Enhancers",
      usage: "Ready to eat products",
    },
    {
      id: 4,
      name: "Protein bar",
      category: "Antifoaming agents",
      usage: "Ready to eat products",
    },
  ]);

  const [selectedRow, setSelectedRow] = useState(null);
  const [message, setMessage] = useState("");
  const [showSuggestions, setShowSuggestions] = useState(false);

  const handleOpenMessageBox = (index) => {
    setSelectedRow(index);
    setMessage("");
  };

  const handleCloseMessageBox = () => {
    setSelectedRow(null);
    setShowSuggestions(false);
  };

  const handleMessageChange = (event) => {
    const value = event.target.value;
    setMessage(value);
  
    setShowSuggestions(value.slice(-1) === "@");
  };

  const handleSelectService = (service) => {
    const updatedMessage = message.replace(/@$/, `@${service} `);
    setMessage(updatedMessage);
    setShowSuggestions(false);
  };

  const handleSendMessage = () => {
    alert(`Message sent: ${message}`);
    handleCloseMessageBox();
  };

  return (
    <Box sx={{ padding: "16px" }}>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          Product Listing
        </Typography>
        <Box>
          <CustomSecondaryDownLoadButton sx={{ mr: 1 }} label={"Download"} />
          <CustomSecondaryEditButton sx={{ mr: 1 }} label={"Edit"} />
        </Box>
      </Grid>

      <TableContainer sx={{ border: "1px solid #ddd", borderRadius: "8px" }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#F9FAFC" }}>
              <TableCell sx={{ fontWeight: "500" }}>SL No.</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Product Name</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Category</TableCell>
              <TableCell sx={{ fontWeight: "500" }}>Usage</TableCell>
              {/* <TableCell sx={{ fontWeight: "500" }}>Actions</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {products.map((product, index) => (
              <TableRow key={product.id}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{product.name}</TableCell>
                <TableCell>{product.category}</TableCell>
                <TableCell>{product.usage}</TableCell>
                {/* <TableCell>
                  <IconButton onClick={() => handleOpenMessageBox(index)}>
                    <MessageIcon />
                  </IconButton>
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {selectedRow !== null && (
        <Paper sx={{ mt: 2, p: 2, borderRadius: "8px" }}>
          <TextField
            fullWidth
            multiline
            value={message}
            onChange={handleMessageChange}
            placeholder="Please provide your feedback..."
          />
          {showSuggestions && (
            <Box sx={{ mt: 1, display: "flex", gap: 1, flexWrap: "wrap" }}>
              {serviceProviders.map((provider) => (
                <Chip
                  key={provider}
                  label={provider}
                  sx={{bgcolor:provider=='CRM'?"#E8DBFF":provider=='Shariah'?"#DBEEFF":provider=="Finance"?"#FBF3E3":provider=="Audit"?"#EDFCF6":provider=="Client"?"#F1DEB9":"#78625B",color:"black",fontWeight:"600","&:hover":{ bgcolor:"inherit",}}}
                  onClick={() => handleSelectService(provider)}
                  clickable
                  color="primary"
                />
              ))}
            </Box>
          )}
          <Grid container justifyContent="flex-end" spacing={1} sx={{ mt: 1 }}>
            <Grid item>
              <Button variant="outlined" sx={{color:"black",bgcolor:"white"}} onClick={handleCloseMessageBox} startIcon={<CloseIcon />}>
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button variant="contained" sx={{color:"white",bgcolor:"black"}} onClick={handleSendMessage}>
                Send
              </Button>
            </Grid>
          </Grid>
        </Paper>
      )}

      <Grid
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 1,
          my: 2,
        }}
      >
        <CustomSecondaryButton label={"Back"} />
        <CustomSuccessButton label={"Approved"} />
      </Grid>
    </Box>
  );
};

export default ProductListPage;
